import { createContext } from 'react';

const LoaderContext = createContext({
  loading: null,
  toggleLoading: () => {}
});

LoaderContext.displayName = 'LoaderContext';
export default LoaderContext;
